module.exports = __webpack_public_path__ + "img/full7-min.19f83325.png";